<template>
    <div>
        <SkeletonBase
            class="mt-3.5"
            :content="1"
            has-divided
        />
        <SkeletonBase
            hasTitle
            class="md:w-1/2 md:mr-2.5 pb-3"
            has-input
        />
        <SkeletonBase has-divided />
        <SkeletonBase hasTitle />
        <div class="relative md:flex w-full mb-5">
            <SkeletonBase
                class="md:w-5/12 md:mr-2.5"
                has-input
            />
            <SkeletonBase
                class="md:w-4/12 md:mr-2.5"
                has-input
            />
            <SkeletonBase
                class="w-1/2 md:w-3/12 md:mr-2.5"
                has-input
            />
            <SkeletonBase
                class="absolute md:static right-0 bottom-0 md:ml-0 w-10 mb-0"
                has-input
            />
        </div>
        <SkeletonBase hasButton />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
